module.exports = __webpack_public_path__ + "img/pink-chevron-up-20x20.8c0e12c7.svg";